module.exports = __webpack_public_path__ + "img/600.669de539.svg";